export var ControlType;
(function (ControlType) {
    ControlType["Corrective"] = "Corrective";
    ControlType["Detective"] = "Detective";
    ControlType["Directive"] = "Directive";
    ControlType["Preventive"] = "Preventive";
})(ControlType || (ControlType = {}));
//# sourceMappingURL=control-type.js.map